var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.motivationList)?_c('div',{staticClass:"d-block text-nowrap"},_vm._l((_vm.motivationList),function(m,index){return _c('span',{key:index,staticClass:"px-1 text-center",class:_vm.getClass(m)},[_vm._v(_vm._s(_vm._f("int")(m))+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }